import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function SoftIcon({ size = 20, color = "white", className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M6.45833 2.9165C4.2725 2.9165 2.5 4.79984 2.5 7.12234C2.5 11.7707 10 17.0832 10 17.0832C10 17.0832 17.5 11.7707 17.5 7.12234C17.5 4.24484 15.7275 2.9165 13.5417 2.9165C11.9917 2.9165 10.65 3.86317 10 5.2415C9.35 3.86317 8.00833 2.9165 6.45833 2.9165Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
